import { render, staticRenderFns } from "./EmailCard.vue?vue&type=template&id=91b97c2e&scoped=true&"
import script from "./EmailCard.vue?vue&type=script&lang=js&"
export * from "./EmailCard.vue?vue&type=script&lang=js&"
import style0 from "./EmailCard.vue?vue&type=style&index=0&id=91b97c2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b97c2e",
  null
  
)

export default component.exports